import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';
import { Observable } from 'rxjs';

@Injectable()
export class MerchantUserService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getMerchantUserAndMerchantForConfirmed(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchantUser/GetMerchantUserAndMerchantForConfirmed', data, messageService);
    }

    public merchantUserUpdate(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchantUser/MerchantUserUpdate', data, messageService);
    }

    public merchantUserDocumentUpload(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchantUser/MerchantUserDocumentUpload', data, messageService);
    }

    public getMerchantUsers(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchantUser/GetMerchantUsers', data, messageService);
    }

    public getUserRoleRights(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchantUser/GetUserRoleRights', data, messageService);
    }

    public createMerchantUser(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/MerchantUser/Create', data, messageService);
    }

    public createMerchantUsers(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/MerchantUser/Bulk/Create', data, messageService);
    }

    public updateMerchantUser(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/MerchantUser/UpdateUser', data, messageService);
    }

    public approvedOrRejectMerchantUserStatus(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchantUser/ApprovedOrRejectMerchantUserStatus', data, messageService);
    }

    public getMerchantUser(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/GetMerchantUser', data, messageService);
    }

    public changePassword(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/MerchantUser/ChangePassword', data, messageService);
    }

    public deleteMerchantUserById(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchantUser/DeleteMerchantUserById', data, messageService);
    }

    public getMerchantUserTemplate(data: any): Observable<any> {
        return this.apiHttp.postObservable('api/AdminMerchantUser/GetMerchantUserTemplate', data);
    }

    public uploadEmployeesXls(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchantUser/UploadEmployeesXls', data, messageService);
    }

    public getMerchantUsersByMerchant(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/GetMerchantUsers', data, messageService);
    }

    public assignStore(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/MerchantUser/AssignStore', data, messageService);
    }

    public suspendUser(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/MerchantUser/Suspend', data, messageService);
    }

    public forceResetPassword(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/MerchantUser/ForceResetPassword', data, messageService);
    }

    public getMerchantUserHistory(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchantUser/GetMerchantUserHistory', data, messageService);
    }
}
